import gql from "graphql-tag";

const DEVICES_QUERY_ENABLED = gql`
  query devicesTable(
    $offset: Int
    $limit: Int
    $sort: [DevicesTableSortInput!]
    $filter: [DevicesTableFilterInput!]
  ) {
    devicesTable(offset: $offset, limit: $limit, sort: $sort, filter: $filter) {
      totalCount
      items {
        id
        bid
        store
        isEnabled
        address
        printedPhotos
        remainingPhotos
        issueCode
        issueDescription
        company
        heartbeat
        status
      }
    }
  }
`;

export default DEVICES_QUERY_ENABLED;
